<template>
  <b-modal
    id="details2"
    title="Dados do Produto"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
    size="xl"
    @show="openModal"
  >
    <div v-if="products && !loading" class="grid-json">
      <div>
        <div v-if="products.name"><b>Nome:</b> {{ products.name }}</div>
        <br />
        <b-form-group v-if="products.images" label="Imagem do Produto">
          <div class="img-produto">
            <b-carousel
              id="carousel-fade"
              style="border-radius: 5px"
              fade
              :controls="products.images.length > 1"
            >
              <b-carousel-slide
                v-for="image in products.images"
                :key="image.id"
                class="image-size"
                :img-src="image.path"
              ></b-carousel-slide>
            </b-carousel>
          </div>
        </b-form-group>
        <b-form-group v-else label="Imagem do Produto">
          <p class="ml-2">Sem Imagem</p>
        </b-form-group>
        <br />
        <div v-if="products.description"
          ><b>Descrição:</b> {{ products.description }}</div
        >
        <br />

        <div v-if="products.type"><b>Tipo:</b> {{ products.type }}</div>
        <br />

        <div v-if="products.status"><b>Status:</b> {{ products.status }}</div>
        <br />

        <div v-if="products.method"><b>Metodos:</b> {{ products.method }}</div>
        <br />

        <div v-if="products.category"
          ><b>Categoria:</b> {{ products.category.name }}</div
        >
        <br />

        <div v-if="products.category_fiscal"
          ><b>Categoria Fiscal:</b> {{ products.category_fiscal }}</div
        >
        <br />

        <div v-if="products.amount"
          ><b>Valor:</b> R$ {{ formatMoney(products.amount) }}</div
        >
      </div>
      <div>
        <JsonViewer
          :value="products || { nenhum_dado_encontrado: '' }"
          class="my-theme"
        />
      </div>
    </div>
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Money from '@src/mixins/money'
import JsonViewer from 'vue-json-viewer'
import ProductService from '@services/resources/ProductService'
var service = ProductService.build()

export default {
  mixins: [Money],
  components: {
    JsonViewer,
  },
  props: {
    productid: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      loading: false,
      products: null,
    }
  },
  methods: {
    openModal() {
      if (this.productid > 0) {
        this.loading = true

        service
          .read(this.productid)
          .then((resp) => {
            this.products = resp.data
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$bvToast.toast('ID deste produto está incorreto', {
          title: 'Produto / Requisições',
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: true,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.grid-json {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}
@media (max-width: 768px) {
  .grid-json {
    grid-template-columns: 1fr;
  }
}
.item-grid {
  max-height: 550px;
  overflow: auto;
}
.item-grid::-webkit-scrollbar {
  width: 12px;
}

.item-grid::-webkit-scrollbar-track {
  background: #f7f7f7;
}

.item-grid::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
  border: 3px solid #f7f7f7;
}
.img-produto {
  max-width: 220px;
}
</style>